// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"694":"3df216de","812":"8243761d"}[chunkId] + ".chunk.js";
};